<template>
  <div>
    <section class="mb-4 mb-lg-5">
      <div class="container">
        <div
          class="image-header"
          :class="{ 'rounded-regular': !authenticated }"
          :style="coverImage"
        ></div>
      </div>
    </section>

    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <h2 class="font-size-medium font-weight-bold mb-4">{{ list && list.name }}</h2>
          <p>{{ list && list.description }}</p>
        </div>

      </div>
    </section>

    <section class="mb-5">
      <div class="container text-center d-flex flex-column flex-lg-row justify-content-center">
         <div :class="{'background-white': !nightMode, 'background-black': nightMode}" class="d-inline-block shadow-light rounded-xl p-2 pl-4 align-self-center d-flex align-items-center min-height-wrap">
          <div class="d-flex mx-auto justify-content-between align-items-center ">
            <div class="d-flex justify-content-center flex-grow-1 mr-4">
              <span class="text-color2 font-size-small">{{ ( list && list.entity_count ) || 0 }} publicações</span>
            </div>
            <div class="d-flex justify-content-center flex-grow-1">
              <router-link
                class="btn btn-outline-color2"
                :to="{ name: 'lists.edit', params: { slug: list ? list.slug : 'slug' } }"
                v-if="list && user && list.user.id === user.id"
              >
                Editar
              </router-link>
            </div>
          </div>
        </div>
        <UserTag
          class="mt-3 mt-lg-0 ml-lg-2 align-self-center align-self-lg-start"
          :user="list ? list.user : null"
        />
        <div
          class="d-block d-md-inline-block mt-2 ml-md-2"
          v-if="list && user && user.id === list.user.id && list.type !== 'readlater'"
        >
          <Button
            class="btn-circle btn-outline-color2 d-inline-block hover-color-white"
            v-b-modal.destroy-list
          >
            <BaseIcon>
              <TrashIcon />
            </BaseIcon>
          </Button>
        </div>
      </div>
      <DestroyListModal
        :list="list"
      />
    </section>

    <section v-if="list">
      <div class="container">
        <div class="mt-3 text-center" v-if="contents.length === 0 && contentLoader">
          <Loader
            color="color2"
            size="big"
          />
        </div>
        <div v-else>
          <ListContentList
            :list="list"
            :contents="contents"
          />
          <div class="mt-3 text-center">
            <Button
              class="btn-outline-color2 btn-lg"
              :loading="contentLoader"
              @click="loadMoreContent"
              v-if="isLoadMoreVisible && contents.length > 0"
            >
              Carregar mais
            </Button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import ListsService from '@/modules/lists/services/lists-service'
import variables from '@/mixins/variables'
import seo from '@/mixins/seo'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import DestroyListModal from '@/components/lists/DestroyListModal.vue'
import ListContentList from '@/components/lists/ListContentList'
import Loader from '@/components/common/Loader/Loader.vue'
import UserTag from '@/components/user/UserTag.vue'

import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import TrashIcon from '@/components/common/Icon/TrashIcon.vue'

export default {
  components: {
    BaseIcon,
    Button,
    DestroyListModal,
    ListContentList,
    Loader,
    TrashIcon,
    UserTag
  },
  mixins: [variables, seo],
  data () {
    return {
      slug: this.$route.params.slug,
      list: null,
      contents: [],
      selectedContent: [],
      page: 1,
      isLoadMoreVisible: true,
      contentLoader: false,
      removeObj: {
        name: '',
        type: '',
        id: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.list ? this.list.name : 'Lista',
      meta: [
        { vmid: 'description', name: 'description', content: this.list && this.list.description ? this.list.description : this.seoDefaultDescription },
        { vmid: 'og-description', name: 'og:description', content: this.list && this.list.description ? this.list.description : this.seoDefaultDescription },
        { vmid: 'og-title', name: 'og:title', content: this.list ? `${this.list.name} | ${this.seoDefaultTitleAppend}` : `${this.seoDefaultTitle} | ${this.seoDefaultTitleAppend}` },
        { vmid: 'og-image', name: 'og:image', content: this.list && this.list.has_cover ? this.list.cover : this.seoDefaultImage }
      ]
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    ...mapState({
      nightMode: state => state.nightMode
    }),
    coverImage () {
      return {
        backgroundImage: this.list ? `url('${this.list.cover}')` : `url('${this.noCoverUrl}')`
      }
    },
    profileImage () {
      return {
        backgroundImage: this.list ? `url('${this.list.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    }
  },
  created () {
    this.getList()
  },
  watch: {
    slug (newSlug, oldSlug) {
      this.getList()
    }
  },
  methods: {
    async getList () {
      try {
        const list = await ListsService.getList(this.$route.params.slug)
        this.list = list
        // console.log(this.list)
        this.getContent()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getContent () {
      this.contentLoader = true
      try {
        const content = await ListsService.getContent({ listId: this.list.id, page: this.page })
        this.contents = [...this.contents, ...content]
        // console.log(this.contents)
        if (content.length <= 0) this.isLoadMoreVisible = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.contentLoader = false
    },
    loadMoreContent () {
      this.page++
      this.getContent()
    }
  }
}
</script>

<style lang="scss" scoped>
.min-height-wrap {
  min-height: 56px;
}
</style>
